import type { JSX } from 'react'
import type { IBannerRowContainerProps } from '../../BannerRowContainer'

import { useMemo } from 'react'
import { BANNER_ASPECT_RATIO } from 'vars/banner-aspect-ratio'
import { BANNER_WIDTH } from 'vars/banner-width'
import { BannerRowContainer } from '../../BannerRowContainer'
import { CellsAlignment, Gaps, RowControlsType } from '../../RowContainer.h'

export interface IBannerRowContainerTemplateProps extends IBannerRowContainerProps {
  setRef?: (node?: Element | null | undefined) => void
  width?: BANNER_WIDTH
  goToNextSlideTrigger?: number
}

export const BannerRowContainerTemplate = ({
  setRef,
  children,
  infiniteLoop = true,
  gap = Gaps.SIZE_40,
  width = BANNER_WIDTH.SIZE_100,
  controlsType = RowControlsType.inRowFluid,
  cellsAlignment = CellsAlignment.Center,
  autoScrollEnabled,
  autoScrollIn,
  color,
  isPopupOpen,
  loaded = true,
  childrenLength,
  onSlideChanged,
  aspectRatio = BANNER_ASPECT_RATIO.SIZE_10,
  dataTestIdBannersCarousel,
  goToNextSlideTrigger,
  initialSlide,
}: IBannerRowContainerTemplateProps): JSX.Element => {
  const bannerContainerWidth = useMemo(() => {
    return childrenLength === 1 ? BANNER_WIDTH.SIZE_100 : width
  }, [childrenLength, width])

  const bannerContainerAspectRatio = useMemo(() => {
    return childrenLength === 1 ? BANNER_ASPECT_RATIO.SIZE_10 : aspectRatio
  }, [aspectRatio, childrenLength])

  return (
    <BannerRowContainer
      setRef={setRef}
      infiniteLoop={infiniteLoop}
      gap={gap}
      width={bannerContainerWidth}
      controlsType={controlsType}
      cellsAlignment={cellsAlignment}
      autoScrollEnabled={autoScrollEnabled}
      autoScrollIn={autoScrollIn}
      color={color}
      isPopupOpen={isPopupOpen}
      loaded={loaded}
      childrenLength={childrenLength}
      onSlideChanged={onSlideChanged}
      aspectRatio={bannerContainerAspectRatio}
      dataTestIdBannersCarousel={dataTestIdBannersCarousel}
      goToNextSlideTrigger={goToNextSlideTrigger}
      initialSlide={initialSlide}
    >
      {children}
    </BannerRowContainer>
  )
}
